import type { FetchEmlItem } from "@/lib/api/storage";
import { writeMessageBodyCache, sanitizeMailMessageDetail } from "@/lib/cache/messageBodyCache";
import { notifyBodiesWarmed } from "@/lib/mail/mailBodyWarmEvents";
import { notifyMailStorageUpdated } from "@/lib/storage/mailStorageEvents";

/** Corps client après archivage .eml (cache session navigateur pour relecture immédiate). */
export async function storeFetchedEmlItems(
  accountId: number,
  folder: string,
  items: FetchEmlItem[]
): Promise<number> {
  let stored = 0;
  const warmedFlags: Record<string, boolean> = {};

  for (const item of items) {
    if (item.error) continue;
    if (item.stored === true || item.skipped === true) {
      stored += 1;
    }
    if (item.message) {
      writeMessageBodyCache(accountId, folder, sanitizeMailMessageDetail(item.message));
      warmedFlags[String(item.uid)] = true;
    }
  }

  if (Object.keys(warmedFlags).length > 0) {
    notifyBodiesWarmed(accountId, folder, warmedFlags);
  }
  if (stored > 0) {
    notifyMailStorageUpdated(accountId, folder);
  }
  return stored;
}
